import React from 'react'

const Message = () => {




  return (

    <div className='flex justify-center items-center flex-col transition ease-in-out delay-1000'>
        
        <p className='md:text-2xl text-sm font-semibold text-yellow-300 max-w-lg w-3/4 text-center mb-16 '>🪔 May the light that we celebrate at Diwali show us the way and lead us together on the path of peace and social harmony.</p>

        <h2 className='md:text-7xl text-3xl font-bold text-center text-transparent h-24 bg-clip-text bg-gradient-to-r from-red-500  to-yellow-500 animate-bounce'>
          Happy Diwali ✨💥
        </h2>
    </div>
  )
}

export default Message